module.exports = __webpack_public_path__ + "static/media/open_external.6b9ec6fd.svg";